"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.statesInverse = exports.stateNumericCodeToAlphaCode = exports.getStateName = exports.SubdivisionNames = exports.USStatesNoTerritories = exports.states = void 0;
//
//  toolkit/states.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 8/7/18.
//  Copyright © 2018-present ContextLogic Inc. All rights reserved.
//

/* Some of these state names are not to be translated */

/* eslint local-rules/unwrapped-i18n: 0 */

/* Keys in these dictionaries are state codes, state names etc */

/* eslint-disable @typescript-eslint/naming-convention */
var states = {
  US: {
    AA: "AA",
    AE: "AE",
    AP: "AP",
    AK: "Alaska",
    AL: "Alabama",
    AR: "Arkansas",
    AS: "American Samoa",
    AZ: "Arizona",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DC: "District of Columbia",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    GU: "Guam",
    HI: "Hawaii",
    IA: "Iowa",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    MA: "Massachusetts",
    MD: "Maryland",
    ME: "Maine",
    MI: "Michigan",
    MN: "Minnesota",
    MO: "Missouri",
    MP: "Northern Mariana Islands",
    MS: "Mississippi",
    MT: "Montana",
    NC: "North Carolina",
    ND: "North Dakota",
    NE: "Nebraska",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NV: "Nevada",
    NY: "New York",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VA: "Virginia",
    VT: "Vermont",
    WA: "Washington",
    WI: "Wisconsin",
    WV: "West Virginia",
    WY: "Wyoming"
  },
  CA: {
    AB: "Alberta",
    BC: "British Columbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NL: "Newfoundland and Labrador",
    NT: "Northwest Territories",
    NS: "Nova Scotia",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Prince Edward Island",
    QC: "Quebec",
    SK: "Saskatchewan",
    YT: "Yukon"
  },
  AU: {
    NSW: "New South Wales",
    ACT: "Australian Capital Territory",
    VIC: "Victoria",
    QLD: "Queensland",
    SA: "South Australia",
    WA: "Western Australia",
    TAS: "Tasmania",
    NT: "Northern Territory",
    JBT: "Jervis Bay Territory"
  },
  MX: {
    ROO: "Quintana Roo",
    SLP: "San Luis Potosí",
    SIN: "Sinaloa",
    SON: "Sonora",
    TAB: "Tabasco",
    TAM: "Tamaulipas",
    TLA: "Tlaxcala",
    VER: "Veracruz",
    CHH: "Chihuahua",
    ZAC: "Zacatecas",
    CHP: "Chiapas",
    DIF: "Distrito Federal",
    BCN: "Baja California",
    BCS: "Baja California Sur",
    CAM: "Campeche",
    COA: "Coahuila",
    COL: "Colima",
    AGU: "Aguascalientes",
    DUR: "Durango",
    YUC: "Yucatán",
    GUA: "Guanajuato",
    GRO: "Guerrero",
    HID: "Hidalgo",
    JAL: "Jalisco",
    MEX: "México",
    MIC: "Michoacán",
    MOR: "Morelos",
    NAY: "Nayarit",
    NLE: "Nuevo León",
    OAX: "Oaxaca",
    PUE: "Puebla",
    QUE: "Querétaro"
  },
  BR: {
    AC: "Acre",
    AL: "Alagoas",
    AM: "Amazonas",
    AP: "Amapá",
    BA: "Bahia",
    CE: "Ceará",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MG: "Minas Gerais",
    MS: "Mato Grosso do Sul",
    MT: "Mato Grosso",
    PA: "Pará",
    PB: "Paraíba",
    PE: "Pernambuco",
    PI: "Piauí",
    PR: "Paraná",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RO: "Rondônia",
    RR: "Roraima",
    RS: "Rio Grande do Sul",
    SC: "Santa Catarina",
    SE: "Sergipe",
    SP: "São Paulo",
    TO: "Tocantins",
    DF: "Distrito Federal"
  },
  CN: {
    AH: "安徽省",
    BJ: "北京市",
    CQ: "重庆市",
    FJ: "福建省",
    GS: "甘肃省",
    GD: "广东省",
    GX: "广西壮族自治区",
    GZ: "贵州省",
    HA: "河南省",
    HB: "湖北省",
    HE: "河北省",
    HI: "海南省",
    HK: "香港特别行政区",
    HL: "黑龙江省",
    HN: "湖南省",
    JL: "吉林省",
    JS: "江苏省",
    JX: "江西省",
    LN: "辽宁省",
    MO: "澳门特别行政区",
    NM: "內蒙古自治区",
    NX: "宁夏回族自治区",
    QH: "青海省",
    SC: "四川省",
    SD: "山东省",
    SH: "上海市",
    SN: "陕西省",
    SX: "山西省",
    TJ: "天津市",
    TW: "台湾省",
    XJ: "新疆维吾尔自治区",
    YN: "云南省",
    ZJ: "浙江省"
  }
};
exports.states = states;
var USTerritories = ["AS", "GU", "MP", "PR", "VI", "FM", "MH", "PW", "AA", "AE", "AP", "CM", "CZ", "PI", "TT"];
var USStatesNoTerritories = Object.keys(states.US).filter(function (sc) {
  return !USTerritories.includes(sc);
});
exports.USStatesNoTerritories = USStatesNoTerritories;
var SubdivisionNames = {
  CA: "Province",
  IT: "Province",
  ES: "Province",
  NO: "Province",
  BE: "Province",
  FI: "Province",
  TR: "Province",
  IE: "Province",
  CN: "Province / Municipality"
};
exports.SubdivisionNames = SubdivisionNames;

var getStateName = function getStateName(countryCode, stateCode) {
  if (stateCode == null || countryCode == null) {
    return "";
  }

  if (countryCode.toUpperCase() in states) {
    // if you find this please fix the any types (legacy)
    return states[countryCode.toUpperCase()][stateCode];
  }

  return "";
};

exports.getStateName = getStateName;
var stateNumericCodeToAlphaCode = {
  "01": "AL",
  "02": "AK",
  "60": "AS",
  "04": "AZ",
  "05": "AR",
  "81": "BI",
  "06": "CA",
  "08": "CO",
  "09": "CT",
  "10": "DE",
  "11": "DC",
  "12": "FL",
  "13": "GA",
  "66": "GU",
  "15": "HI",
  "16": "ID",
  "17": "IL",
  "18": "IN",
  "19": "IA",
  "20": "KS",
  "21": "KY",
  "22": "LA",
  "23": "ME",
  "24": "MD",
  "25": "MA",
  "26": "MI",
  "27": "MN",
  "28": "MS",
  "29": "MO",
  "30": "MT",
  "31": "NE",
  "32": "NV",
  "33": "NH",
  "34": "NJ",
  "35": "NM",
  "36": "NY",
  "37": "NC",
  "38": "ND",
  "39": "OH",
  "40": "OK",
  "41": "OR",
  "42": "PA",
  "72": "PR",
  "44": "RI",
  "45": "SC",
  "46": "SD",
  "47": "TN",
  "48": "TX",
  "49": "UT",
  "50": "VT",
  "51": "VA",
  "78": "VI",
  "53": "WA",
  "54": "WV",
  "55": "WI",
  "56": "WY"
};
exports.stateNumericCodeToAlphaCode = stateNumericCodeToAlphaCode;
var statesInverse = {
  US: {
    AA: "AA",
    AE: "AE",
    AP: "AP",
    Alaska: "AK",
    Alabama: "AL",
    Arkansas: "AR",
    "American Samoa": "AS",
    Arizona: "AZ",
    California: "CA",
    Colorado: "CO",
    Connecticut: "CT",
    "District of Columbia": "DC",
    Delaware: "DE",
    Florida: "FL",
    Georgia: "GA",
    Guam: "GU",
    Hawaii: "HI",
    Iowa: "IA",
    Idaho: "ID",
    Illinois: "IL",
    Indiana: "IN",
    Kansas: "KS",
    Kentucky: "KY",
    Louisiana: "LA",
    Massachusetts: "MA",
    Maryland: "MD",
    Maine: "ME",
    Michigan: "MI",
    Minnesota: "MN",
    Missouri: "MO",
    "Northern Mariana Islands": "MP",
    Mississippi: "MS",
    Montana: "MT",
    "North Carolina": "NC",
    "North Dakota": "ND",
    Nebraska: "NE",
    "New Hampshire": "NH",
    "New Jersey": "NJ",
    "New Mexico": "NM",
    Nevada: "NV",
    "New York": "NY",
    Ohio: "OH",
    Oklahoma: "OK",
    Oregon: "OR",
    Pennsylvania: "PA",
    "Rhode Island": "RI",
    "South Carolina": "SC",
    "South Dakota": "SD",
    Tennessee: "TN",
    Texas: "TX",
    Utah: "UT",
    Virginia: "VA",
    Vermont: "VT",
    Washington: "WA",
    Wisconsin: "WI",
    "West Virginia": "WV",
    Wyoming: "WY"
  },
  CA: {
    Alberta: "AB",
    "British Columbia": "BC",
    Manitoba: "MB",
    "New Brunswick": "NB",
    "Newfoundland and Labrador": "NL",
    "Northwest Territories": "NT",
    "Nova Scotia": "NS",
    Nunavut: "NU",
    Ontario: "ON",
    "Prince Edward Island": "PE",
    Quebec: "QC",
    Saskatchewan: "SK",
    Yukon: "YT"
  },
  AU: {
    "New South Wales": "NSW",
    "Australian Capital Territory": "ACT",
    Victoria: "VIC",
    Queensland: "QLD",
    "South Australia": "SA",
    "Western Australia": "WA",
    Tasmania: "TAS",
    "Northern Territory": "NT",
    "Jervis Bay Territory": "JBT"
  },
  MX: {
    "Quintana Roo": "ROO",
    "San Luis Potosí": "SLP",
    Sinaloa: "SIN",
    Sonora: "SON",
    Tabasco: "TAB",
    Tamaulipas: "TAM",
    Tlaxcala: "TLA",
    Veracruz: "VER",
    Chihuahua: "CHH",
    Zacatecas: "ZAC",
    Chiapas: "CHP",
    "Distrito Federal": "DIF",
    "Baja California": "BCN",
    "Baja California Sur": "BCS",
    Campeche: "CAM",
    Coahuila: "COA",
    Colima: "COL",
    Aguascalientes: "AGU",
    Durango: "DUR",
    Yucatán: "YUC",
    Guanajuato: "GUA",
    Guerrero: "GRO",
    Hidalgo: "HID",
    Jalisco: "JAL",
    México: "MEX",
    Michoacán: "MIC",
    Morelos: "MOR",
    Nayarit: "NAY",
    "Nuevo León": "NLE",
    Oaxaca: "OAX",
    Puebla: "PUE",
    Querétaro: "QUE"
  },
  BR: {
    Acre: "AC",
    Alagoas: "AL",
    Amazonas: "AM",
    Amapá: "AP",
    Bahia: "BA",
    Ceará: "CE",
    "Espírito Santo": "ES",
    Goiás: "GO",
    Maranhão: "MA",
    "Minas Gerais": "MG",
    "Mato Grosso do Sul": "MS",
    "Mato Grosso": "MT",
    Pará: "PA",
    Paraíba: "PB",
    Pernambuco: "PE",
    Piauí: "PI",
    Paraná: "PR",
    "Rio de Janeiro": "RJ",
    "Rio Grande do Norte": "RN",
    Rondônia: "RO",
    Roraima: "RR",
    "Rio Grande do Sul": "RS",
    "Santa Catarina": "SC",
    Sergipe: "SE",
    "São Paulo": "SP",
    Tocantins: "TO",
    "Distrito Federal": "DF"
  },
  CN: {
    安徽省: "AH",
    北京市: "BJ",
    重庆市: "CQ",
    福建省: "FJ",
    甘肃省: "GS",
    广东省: "GD",
    广西壮族自治区: "GX",
    贵州省: "GZ",
    河南省: "HA",
    湖北省: "HB",
    河北省: "HE",
    海南省: "HI",
    香港特别行政区: "HK",
    黑龙江省: "HL",
    湖南省: "HN",
    吉林省: "JL",
    江苏省: "JS",
    江西省: "JX",
    辽宁省: "LN",
    澳门特别行政区: "MO",
    內蒙古自治区: "NM",
    宁夏回族自治区: "NX",
    青海省: "QH",
    四川省: "SC",
    山东省: "SD",
    上海市: "SH",
    陕西省: "SN",
    山西省: "SX",
    天津市: "TJ",
    台湾省: "TW",
    新疆维吾尔自治区: "XJ",
    云南省: "YN",
    浙江省: "ZJ"
  }
};
exports.statesInverse = statesInverse;
var _default = states;
exports["default"] = _default;